export const createFileURL = (file) => {
  return URL.createObjectURL(file);
};

export const removeFileURL = (fileUrl) => {
  return URL.revokeObjectURL(fileUrl);
};
